<template>
  <div
    :class="{
      'stats-tab': this.sector !== 'placement',
      'stats-tab-p': this.sector === 'placement',
      'stats-tab-l': this.sector === 'location',
      'stats-tab-adv': this.sector === 'advertising'
    }"
    v-show="campaignTab && showStatistics"
  >
    <!--      <div class="enlarge-div">-->
    <!--        <i-->
    <!--            class="fas fa-arrow-up enlarge-table"-->
    <!--            @click="enlargeTable(true)"-->
    <!--            v-if="!tableEnlarged"-->
    <!--        ></i>-->
    <!--        <i-->
    <!--            v-else-->
    <!--            class="fas fa-arrow-down enlarge-table-down"-->
    <!--            @click="enlargeTable(false)"-->
    <!--        ></i>-->
    <!--      </div>-->
    <div class="stats-table">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th v-if="CheckUserPermission([1, 2, 3, 12])">
              <button
                @click="applyAmountSortingFuture"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountFuture === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountFuture === 'desc'
                  }"
                ></span>
              </button>

              <button
                @click="applyCostSortingFuture"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostFuture === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostFuture === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingDep"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountDep === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountDep === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingDep"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentDep === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentDep === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="CheckUserPermission([1, 2, 3, 12])"
                @click="applyCostSortingDep"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostDep === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostDep === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingCR"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountCR === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountCR === 'desc'
                  }"
                ></span>
              </button>
            </th>

            <th>
              <button
                @click="applyAmountSortingDepTotal"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down':
                      sortOrderAmountTotalDep === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountTotalDep === 'desc'
                  }"
                ></span>
              </button>

              <button
                @click="applyPercentSortingDepTotal"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down':
                      sortOrderPercentTotalDep === 'asc',
                    'fas fa-sort-numeric-up':
                      sortOrderPercentTotalDep === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="CheckUserPermission([1, 2, 3, 12])"
                @click="applyCostSortingDepTotal"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostTotalDep === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostTotalDep === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingCTR"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountCTR === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountCTR === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingTotal"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountTotal === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountTotal === 'desc'
                  }"
                ></span>
              </button>
              <!--                  <button
                              @click="applyPercentSortingTotal"
                              class="btn btn-default btn-sm override"
                            >
                              <span
                                class="fa"
                                :class="{
                                  'fas fa-sort-numeric-down':
                                    sortOrderPercentTotal === 'asc',
                                  'fas fa-sort-numeric-up':
                                    sortOrderPercentTotal === 'desc'
                                }"
                              ></span>
                            </button>-->
              <button
                v-if="CheckUserPermission([1, 2, 3, 12])"
                @click="applyCostSortingTotal"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostTotal === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostTotal === 'desc'
                  }"
                ></span>
              </button>
            </th>

            <th v-if="CheckUserPermission([1, 2, 3, 12])">
              <button
                @click="applyCostSortingPL"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostPL === 'asc',
                    'fas fa-funnel-dollar funnel-up': sortOrderCostPL === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applySortingById"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-down': sortOrderId === 'asc',
                    'fas fa-sort-up': sortOrderId === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="th-camp">
              <div class="drop-down-root">
                <div class="dropdown">
                  <div
                    class="selected-cal dropdown-toggle"
                    :data-toggle="
                      this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])
                        ? 'dropdown'
                        : false
                    "
                  >
                    {{ selectedTopFilter }}
                    <!--                      {{ this.totalCount > 0 ||this.totalCount !== undefined ?  '('  : '' }}-->
                    <!--                      {{ this.totalCount !== 0  ?  this.totalCount  : 0 }}-->
                    <!--                      {{ this.totalCount > 0 || this.totalCount !== undefined  ?  ')'  : ''  }}-->
                  </div>
                  <ul class="dropdown-menu ul-filters">
                    <li
                      v-for="tab in filterPresets"
                      :key="tab.id"
                      :class="{
                        activedrop: selectedTopFilter === tab.alias
                      }"
                      @click="setKeyWordFilterTab(tab.alias)"
                    >
                      <a>
                        {{ tab.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="showAllDataStatus = 3"
                class="btn btn-default btn-sm override"
                :class="{
                  'btn-highlight': showAllDataStatus === 3
                }"
              >
                <span class="fa filter-btn-font-shekel">₪</span>
              </button>
              <button
                @click="showAllDataStatus = 2"
                class="btn btn-default btn-sm override"
                :class="{
                  'btn-highlight': showAllDataStatus === 2
                }"
              >
                <span class="fa filter-btn-font">%</span>
              </button>
              <button
                @click="showAllDataStatus = 1"
                class="btn btn-default btn-sm override"
                :class="{
                  'btn-highlight': showAllDataStatus === 1
                }"
              >
                <span class="fa filter-btn-font">C</span>
              </button>
              <button
                @click="showAllDataStatus = 0"
                class="btn btn-default btn-sm override"
                :class="{
                  'btn-highlight': showAllDataStatus === 0
                }"
              >
                <span class="fa filter-btn-font">A</span>
              </button>
            </th>

            <th>
              <button
                @click="applyAmountSortingAll"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountAll === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountAll === 'desc'
                  }"
                ></span>
              </button>

              <button
                @click="applyPercentSortingAll"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentAll === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentAll === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingAll"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostAll === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostAll === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingNa"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountNa === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountNa === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingNa"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentNa === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentNa === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingNa"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostNa === 'asc',
                    'fas fa-funnel-dollar funnel-up': sortOrderCostNa === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingNi"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountNi === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountNi === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingNi"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentNi === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentNi === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingNi"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostNi === 'asc',
                    'fas fa-funnel-dollar funnel-up': sortOrderCostNi === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingBn"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountBn === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountBn === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingBn"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentBn === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentBn === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingBn"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostBn === 'asc',
                    'fas fa-funnel-dollar funnel-up': sortOrderCostBn === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              <button
                @click="applyAmountSortingT4"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountT4 === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountT4 === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingT4"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentT4 === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentT4 === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingT4"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostT4 === 'asc',
                    'fas fa-funnel-dollar funnel-up': sortOrderCostT4 === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <!--sorting ended stats-->
            <th>
              <button
                @click="applyAmountSortingEnded"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountEnded === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountEnded === 'desc'
                  }"
                ></span>
              </button>
              <button
                @click="applyPercentSortingEnded"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderPercentEnded === 'asc',
                    'fas fa-sort-numeric-up': sortOrderPercentEnded === 'desc'
                  }"
                ></span>
              </button>
              <button
                v-if="checkPermissions(auth, [1, 2, 3, 12])"
                @click="applyCostSortingEnded"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-funnel-dollar': sortOrderCostEnded === 'asc',
                    'fas fa-funnel-dollar funnel-up':
                      sortOrderCostEnded === 'desc'
                  }"
                ></span>
              </button>
            </th>
          </tr>

          <tr class="bg-blue">
            <!-- <th></th>-->
            <th v-if="checkPermissions(auth, [1, 2, 3, 12])">
              FUTURE
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('FUTURE')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              CLIENTS DEP
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'CLI_DEP')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('CLI_DEP') &&
                      'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              CR
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('CR')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              TOTAL DEP
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('TOTAL_DEP')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              CTR
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('CTR')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              ALL
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('ALL')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th v-if="checkPermissions(auth, [1, 2, 3, 12])">
              P/L
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('PL')"
                ><img
                  class="charts-icon"
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th></th>
            <th>CAMPAIGN</th>

            <th>
              ACTIVE
              <span @click="handleChartLoad('GROUP', 'AC')"
                ><img
                  v-if="keywordFullStats.length > 0"
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('AC') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <!--'was alll-->
            <th>
              NR
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'NA')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('NA') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              NI
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'NI')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('NI') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              BN
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'BN')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('BN') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <th>
              T4
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'T4')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('T4') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>

            <th>
              ENDED
              <span
                v-if="keywordFullStats.length > 0"
                @click="handleChartLoad('GROUP', 'ENDED')"
                ><img
                  class="charts-icon"
                  :class="
                    chartGroupSubCatSelector.includes('END') && 'btn-highlight'
                  "
                  src="img/statistics/statistics.svg"
                  alt="charts"
              /></span>
            </th>
            <!--was total-->
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(stat, idx) in paginate(
              keywordFullStats,
              pageNum,
              fullStatsPageSize
            )"
            :key="idx"
          >
            <td v-if="checkPermissions(auth, [1, 2, 3, 12])">
              <!--                  {{ ((stat.ov_dep_percent / 100) * stat.all).toFixed(0) }} |
                            <span
                              :class="{
                                'green-pl':
                                  Math.sign(
                                    2700 * ((stat.ov_dep_percent / 100) * stat.all)
                                  ) === 1,
                                'red-pl':
                                  Math.sign(
                                    2700 * ((stat.ov_dep_percent / 100) * stat.all)
                                  ) === -1
                              }"
                              >{{
                                (2700 * ((stat.ov_dep_percent / 100) * stat.all))
                                  .toFixed(0)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }}₪</span
                            >-->

              <span
                v-if="
                  showAllDataStatus === 0 ||
                    showAllDataStatus === 1 ||
                    showAllDataStatus === 2
                "
                >{{ stat.future_dep_count.toFixed(0) }}</span
              >
              <span
                v-if="
                  showAllDataStatus === 0 ||
                    showAllDataStatus === 2 ||
                    showAllDataStatus === 3
                "
              >
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                  |
                </span>
                <span
                  :class="{
                    'green-pl': Math.sign(stat.future_pl) === 1,
                    'red-pl': Math.sign(stat.future_pl) === -1
                  }"
                >
                  {{
                    stat.future_pl
                      .toFixed(0)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪</span
                >
              </span>
            </td>

            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.dep
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.dep_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.dep_cost
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td>{{ stat.cr.toFixed(2) }}</td>
            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.ov_dep
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.ov_dep_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.ov_dep_avg_cpa
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td>{{ stat.ctr.toFixed(2) }}</td>

            <td>
              <span
                v-if="
                  showAllDataStatus === 0 ||
                    showAllDataStatus === 1 ||
                    showAllDataStatus === 2
                "
                >{{ stat.total }}</span
              >
              <span
                v-if="
                  (showAllDataStatus === 0 ||
                    showAllDataStatus === 2 ||
                    showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                  |
                </span>
                {{
                  stat.total_cost
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td v-if="checkPermissions(auth, [1, 2, 3, 12])">
              <span
                :class="{
                  'green-pl': Math.sign(stat.pl) === 1,
                  'red-pl': Math.sign(stat.pl) === -1
                }"
                >{{
                  stat.pl.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>

            <td class="td-check">
              <!--
                            <span>{{ keywordFullStats.indexOf(stat) + 1 }}.</span>
          -->

              <label class="top-check-label" :for="stat">
                {{ stat.key }}.
                <input
                  type="checkbox"
                  class="top-check"
                  v-model="selectedCampForChart"
                  :value="stat"
                  :id="stat"
                />
              </label>
              <span
                class="fas fa-lock-open pointer"
                @mouseleave="selectedCampIdForPopup = null"
                @mouseenter="selectedCampIdForPopup = stat.key"
                @click="manageKeywordsStatus(stat.id, 1)"
                v-if="stat.status === null || stat.status === 0"
              ></span>
              <span
                class="fas fa-lock pointer"
                @mouseleave="selectedCampIdForPopup = null"
                @mouseenter="selectedCampIdForPopup = stat.key"
                @click="manageKeywordsStatus(stat.id, 0)"
                v-if="stat.status === 1"
              ></span>

              <div class="floating-wrapper">
                <div
                  class="close-history-popup"
                  v-if="
                    stat.status_log.length > 0 &&
                      selectedCampIdForPopup === stat.key
                  "
                >
                  <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr v-for="item in stat.status_log" :key="item.id">
                          <td>{{ item.user.full_name }}</td>
                          <td>
                            <span
                              class="fas fa-lock-open pointer"
                              v-if="item.status === 0"
                            ></span
                            ><span
                              class="fas fa-lock pointer"
                              v-if="item.status === 1"
                            ></span>
                          </td>
                          <td>
                            {{ formatDateTimeTable(item.created_at) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>

            <td class="td-camp" @click="applyIndividualCampFiltering(stat.id)">
              {{ stat.id }}
            </td>
            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.all
              }}</span>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.all_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.all_cost
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>

            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.na
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.na_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.na_cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.ni
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.ni_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.ni_cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.bn
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.bn_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.bn_cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.t4
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.t4_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.t4_cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>

            <td>
              <span v-if="showAllDataStatus === 0 || showAllDataStatus === 1">{{
                stat.ended
              }}</span
              ><span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                <span v-if="showAllDataStatus === 0"> | </span>
                {{ stat.ended_percent.toFixed(0) }}%</span
              ><span
                v-if="
                  (showAllDataStatus === 0 || showAllDataStatus === 3) &&
                    checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                <span v-if="showAllDataStatus === 0"> | </span>
                {{
                  stat.ended_cost
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}₪</span
              >
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr></tr>

          <!--             <tr
                      v-if="
                        checkPermissions(auth, [1, 2, 3]) && keywordFullStats.length > 0
                      "
                    >-->
          <tr>
            <td v-if="checkPermissions(auth, [1, 2, 3, 12])">
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="
                    showAllDataStatus === 0 ||
                      showAllDataStatus === 1 ||
                      showAllDataStatus === 2
                  "
                  >{{ sumFuture().count_total.toFixed(0) }}</span
                >
                <span
                  v-if="
                    showAllDataStatus === 0 ||
                      showAllDataStatus === 2 ||
                      showAllDataStatus === 3
                  "
                >
                  <span
                    v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >
                    |
                  </span>
                  <span
                    :class="{
                      'green-pl': Math.sign(sumFuture().cost_total) === 1,
                      'red-pl': Math.sign(sumFuture().cost_total) === -1
                    }"
                  >
                    {{
                      sumFuture()
                        .cost_total.toFixed(0)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                </span>
              </span>
            </td>

            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumClientsDep().count_total }}</span
                >
                <span v-if="showAllDataStatus === 0">
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumClientsDep().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumClientsDep().cost_total }}₪</span
                >
              </span>
            </td>
            <!--clients dep-->
            <td>
              <span v-if="keywordFullStats.length > 0">{{
                sumCR().percent_total
              }}</span>
            </td>
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumClientsTotalDep().count_total }}</span
                >
                <span v-if="showAllDataStatus === 0">
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumClientsTotalDep().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumClientsTotalDep().cost_total }}₪</span
                >
              </span>
            </td>
            <td>
              <span v-if="keywordFullStats.length > 0">{{ sumCTR().ctr }}</span>
            </td>
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="
                    showAllDataStatus === 0 ||
                      showAllDataStatus === 1 ||
                      showAllDataStatus === 2
                  "
                  >{{ sumClientsTotal().count_total }}</span
                >
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2">
                  |
                </span>
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 ||
                        showAllDataStatus === 3 ||
                        showAllDataStatus === 2)
                  "
                  >{{ sumClientsTotal().cost_total }}₪</span
                >
              </span>
            </td>
            <td>
              <span
                v-if="
                  checkPermissions(auth, [1, 2, 3, 12]) &&
                    keywordFullStats.length > 0
                "
              >
                <span
                  :class="{
                    'green-pl': Math.sign(parseInt(sumPL().cost_total)) === 1,
                    'red-pl': Math.sign(parseInt(sumPL().cost_total)) === -1
                  }"
                  >{{ sumPL().cost_total }}₪</span
                >
              </span>
            </td>
            <td></td>
            <td>
              <div class="tag-form-btns">
                <!--                    <a
                  class="tag-form-cancel-btn"
                  href="javascript:void(0)"
                  @click.prevent="closeSelect"
                  ><span class="fas fa-times"></span
                ></a>-->
                <a
                  class="tag-form-cancel-btn"
                  href="javascript:void(0)"
                  @click.prevent="applyFilter"
                  ><span class="fas fa-check"></span
                ></a>

                <div class="paginationContainer text-center">
                  <div class="btn-group ">
                    <button
                      v-if="pageNum !== 1"
                      @click="backPage"
                      class="btn btn-sm s-btn-sm page-btn"
                      :disabled="pageNum === 1"
                    >
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <span class="btn btn-sm s-btn-sm page-num ">
                      {{ pageNum }}
                    </span>
                    <button
                      v-if="
                        paginate(
                          keywordFullStats,
                          pageNum + 1,
                          fullStatsPageSize
                        ).length !== 0
                      "
                      @click="nextPage"
                      class="btn btn-sm s-btn-sm page-btn"
                      :disabled="
                        paginate(
                          keywordFullStats,
                          pageNum + 1,
                          fullStatsPageSize
                        ).length === 0
                      "
                    >
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
                <a
                  class="tag-form-ok-btn"
                  href="javascript:void(0)"
                  @click.prevent="resetSelect"
                  ><span class="fas fa-sync"></span
                ></a>
                <button class="bttn-tab" @click="selectedKeywordMsTab = 'MAIN'">
                  MAIN
                </button>
              </div>
            </td>
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumActive().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumActive().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumActive().cost_total }}₪</span
                >
              </span>
            </td>

            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumNa().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumNa().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumNa().cost_total }}₪</span
                >
              </span>
            </td>

            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumNi().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>

                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumNi().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumNi().cost_total }}₪</span
                >
              </span>
            </td>
            <!--ni-->
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumBn().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumBn().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumBn().cost_total }}₪</span
                >
              </span>
            </td>
            <!--bn-->
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumT4().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumT4().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumT4().cost_total }}₪</span
                >
              </span>
            </td>
            <!--sum ended-->
            <td>
              <span v-if="keywordFullStats.length > 0">
                <span
                  v-if="showAllDataStatus === 0 || showAllDataStatus === 1"
                  >{{ sumEnded().count_total }}</span
                >
                <span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  |
                </span>
                <span v-if="showAllDataStatus === 0 || showAllDataStatus === 2"
                  >{{ sumEnded().percent_total }}%</span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      showAllDataStatus === 0
                  "
                >
                  | </span
                ><span
                  v-if="
                    checkPermissions(auth, [1, 2, 3, 12]) &&
                      (showAllDataStatus === 0 || showAllDataStatus === 3)
                  "
                  >{{ sumEnded().cost_total }}₪</span
                >
              </span>
            </td>

            <!-- <th>{{  sumFuture().count_total }} | <span :class="{
                        'green-pl':Math.sign(parseInt(sumFuture().cost_total)) === 1 ,
                        'red-pl':Math.sign(parseInt(sumFuture().cost_total)) === -1 ,
                      }">{{  sumFuture().cost_total }}₪</span></th>-->
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import apiClientCreator from "@/helpers/api/request";
import moment from "moment";
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";
// import Loader from "@/main/misc.main/loader/Loader";

export default {
  name: "StatisticsExpansion",
  props: {
    msSelectedItems: {
      type: Array,
      default: () => []
    },
    showStatistics: {
      type: Boolean,
      default: false
    },
    expandToRight: {
      type: Boolean,
      default: false
    },
    selectedMainTab: {
      type: String
    },
    hasTabs: {
      type: Boolean
    },
    questionTab: {
      type: Boolean,
      required: false
    },
    questionId: {
      type: Number,
      required: false
    },
    campaignTab: {
      type: Boolean,
      required: false
    },
    extSearch: {
      type: Boolean,
      required: false
    },
    sector: {
      type: String
    },
    queryObject: {
      type: Object
    },
    open: {
      type: Boolean,
      default: false
    },
    resetList: {
      type: Boolean,
      default: false,
      required: false
    },
    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  mixins: [UsersPermissionCheck],
  // components: {
  //   Loader
  // },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "selectRegCalMonth",
      "selectRegCalLastMonth",
      "filterDepTimeFrame",
      "chartsMainView",
      "campChartData"
    ])
  },
  data() {
    return {
      filterPresets: [
        {
          id: 1,
          name: "REG",
          alias: "REG"
        },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 3,
          name: "ALL",
          alias: "ALL"
        }
      ],
      selectedTopFilter: "REG",
      selectedItems: [],
      infoData: [],
      openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      showItemsCount: false,
      selectAll: false,
      keywordsList: [],
      keywordStats: [],
      keywordFullStats: [],
      requestClickBusy: false,
      requestFullStatsBusy: false,
      requestCloseCamp: false,
      sortOrderAlpha: "asc",
      sortOrderAmount: "asc",

      sortOrderPercentAll: "asc",
      sortOrderAmountAll: "asc",
      sortOrderCostAll: "asc",

      sortOrderPercentNa: "asc",
      sortOrderAmountNa: "asc",
      sortOrderCostNa: "asc",

      sortOrderPercentNi: "asc",
      sortOrderAmountNi: "asc",
      sortOrderCostNi: "asc",

      sortOrderPercentBn: "asc",
      sortOrderAmountBn: "asc",
      sortOrderCostBn: "asc",

      sortOrderPercentT4: "asc",
      sortOrderAmountT4: "asc",
      sortOrderCostT4: "asc",

      sortOrderPercentEnded: "asc",
      sortOrderAmountEnded: "asc",
      sortOrderCostEnded: "asc",

      sortOrderPercentTotal: "asc",
      sortOrderAmountTotal: "asc",
      sortOrderCostTotal: "asc",

      sortOrderPercentDep: "asc",
      sortOrderAmountDep: "asc",
      sortOrderCostDep: "asc",

      sortOrderPercentTotalDep: "asc",
      sortOrderAmountTotalDep: "asc",
      sortOrderCostTotalDep: "asc",

      sortOrderPercentCR: "asc",
      sortOrderAmountCR: "asc",

      sortOrderAmountCTR: "asc",

      sortOrderCostPL: "asc",

      sortOrderAmountFuture: "asc",
      sortOrderCostFuture: "asc",

      sortOrderId: "asc",
      showAllDataStatus: 0,

      selectedKeywordMsTab: "MAIN",
      aaidMsTabs: [
        {
          id: 1,
          name: "Main",
          alias: "MAIN"
        },
        {
          id: 2,
          name: "Statistics",
          alias: "STATS"
        }
      ],
      pageNum: 1,
      statsPageNum: 1,
      fullStatsPageSize: 6,
      tableEnlarged: false,
      requests: [],
      request: null,
      selectedCampForChart: [],
      selectedChartCat: 0,
      selectedCampIdForPopup: null,
      selectedChartType: 0,
      chartGroupSubCatSelector: ["NR", "NI", "BN", "T4", "END", "CLI_DEP", "AC"]
    };
  },
  methods: {
    setKeyWordFilterTab(filter) {
      this.selectedTopFilter = filter;
      this.$store.commit("clients/setRegCalFilterNoDate", filter);
    },
    enlargeTable(cond) {
      if (cond && this.keywordFullStats.length > 16) {
        this.tableEnlarged = true;
        this.fullStatsPageSize = 17;
      }
      if (!cond) {
        this.tableEnlarged = false;
        this.fullStatsPageSize = 6;
      }
    },
    applyIndividualCampFiltering(campId) {
      const opt = { type: campId };
      this.$emit("input", [opt]);
      this.$emit("apply");
    },

    applyFilter() {
      this.$emit("input", this.selectedItems);
      this.$emit("apply");
    },
    /*    handleBnChartLoad() {
              this.$store.commit("clients/setChartsMainView", "CAMP");
              let arr = this.paginate(this.keywordFullStats,this.pageNum,6);
              this.selectedCampForChart.forEach(stat=>{
                arr = arr.filter(item=>item.key !== stat.key)
              })
              const checkLen =this.paginate(this.selectedCampForChart,this.pageNum,6-arr.length) ///this.paginate(this.selectedCampForChart,this.pageNum+1,6);
              if(checkLen.length>0) {
                this.$store.commit("clients/setCampChartData", this.paginate(this.selectedCampForChart, this.pageNum, 6 - arr.length));
              }
            },*/
    handleChartLoad(category, subCategory) {
      this.selectedChartCat = category;
      this.selectedChartSubCat = subCategory;

      this.$store.commit("clients/setChartsMainView", "CAMP");

      if (subCategory === "NA") {
        if (this.chartGroupSubCatSelector.includes("NA")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "NA"
          );
        } else {
          this.chartGroupSubCatSelector.push("NA");
        }
      }
      if (subCategory === "NI") {
        if (this.chartGroupSubCatSelector.includes("NI")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "NI"
          );
        } else {
          this.chartGroupSubCatSelector.push("NI");
        }
      }

      if (subCategory === "BN") {
        if (this.chartGroupSubCatSelector.includes("BN")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "BN"
          );
        } else {
          this.chartGroupSubCatSelector.push("BN");
        }
      }

      if (subCategory === "T4") {
        if (this.chartGroupSubCatSelector.includes("T4")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "T4"
          );
        } else {
          this.chartGroupSubCatSelector.push("T4");
        }
      }
      if (subCategory === "ENDED") {
        if (this.chartGroupSubCatSelector.includes("END")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "END"
          );
        } else {
          this.chartGroupSubCatSelector.push("END");
        }
      }
      if (subCategory === "AC") {
        if (this.chartGroupSubCatSelector.includes("AC")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "AC"
          );
        } else {
          this.chartGroupSubCatSelector.push("AC");
        }
      }
      if (subCategory === "CLI_DEP") {
        if (this.chartGroupSubCatSelector.includes("CLI_DEP")) {
          this.chartGroupSubCatSelector = this.chartGroupSubCatSelector.filter(
            item => item !== "CLI_DEP"
          );
        } else {
          this.chartGroupSubCatSelector.push("CLI_DEP");
        }
      }

      this.$store.commit("clients/setCampChartData", {
        cat: category,
        subCat: this.chartGroupSubCatSelector,
        typeCat: this.selectedChartType,
        data: this.paginate(
          this.keywordFullStats,
          this.pageNum,
          this.fullStatsPageSize
        )
      });
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    searchStats(slug) {
      if (
        !this.requestClickBusy //&&
        // this.keywordStats.length < this.options.length
      ) {
        this.$store.commit("clients/setLoading", true);

        this.requestClickBusy = true;
        const id = this.keywordStats.length;

        const q = this.queryObject;
        const qSlug = { search: slug };
        const query = { ...q, ...qSlug };

        apiClientCreator(`client/stats/campaign/keyword/search/ids`)
          .get("", { params: query })
          .then(res => {
            this.keywordsList = res.data;
            //console.log(this.keywordsList.length)
            this.requestClickBusy = false;
            this.$store.commit("clients/setLoading", false);

            this.searchStatsData(slug);
          });
      }
    },

    searchStatsData(slug) {
      if (this.open && this.selectedKeywordMsTab === "MAIN") {
        this.$store.commit("clients/setLoading", true);

        this.requestClickBusy = true;
        let id;
        if (this.result.length > 0) {
          id = this.result[0].id - 1;
          this.keywordStats = [];
        } else {
          id = this.keywordStats.length;
        }
        const q = this.queryObject;
        const qSlug = { search: slug };
        const query = { ...q, ...qSlug };

        apiClientCreator(`client/stats/campaign/keyword/stats/search/${id}`)
          .get("", { params: query })
          .then(res => {
            res.data.map(item => {
              if (this.open) {
                this.keywordStats.push(item);
                this.keywordStats.sort((a, b) => {
                  if (a.count > b.count) {
                    return -1;
                  }
                  if (a.count < b.count) {
                    return 1;
                  }
                  return 0;
                });
              }
            });
            this.requestClickBusy = false;
            this.$store.commit("clients/setLoading", false);

            if (this.keywordStats.length < this.keywordsList.length) {
              this.fetchStatsData();
            }
            if (!this.open) {
              this.keywordsList = [];
              this.keywordStats = [];
            }
            //
          });
      }
    },

    fetchStats() {
      // this.fetchStatsData();
      if (
        !this.requestClickBusy //&&
        // this.keywordStats.length < this.options.length
      ) {
        this.$store.commit("clients/setLoading", true);
        this.requestClickBusy = true;
        const id = this.keywordStats.length;
        apiClientCreator(`client/stats/campaign/keyword/ids`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.keywordsList = res.data;
            //console.log(this.keywordsList.length)
            this.requestClickBusy = false;
            this.$store.commit("clients/setLoading", false);

            this.fetchStatsData();
          });
      }
    },

    fetchStatsData() {
      //   const axiosSource = apiClientCreator.CancelToken_
      //   this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

      if (this.open && this.selectedKeywordMsTab === "MAIN") {
        this.$store.commit("clients/setLoading", true);
        this.requestClickBusy = true;
        let id;
        if (this.result.length > 0) {
          id = this.result[0].id - 1;
          this.keywordStats = [];
        } else {
          id = this.keywordStats.length;
        }
        apiClientCreator(`client/stats/campaign/keyword/stats/${id}`)
          .get("", { params: this.queryObject })
          .then(res => {
            res.data.map(item => {
              if (this.open) {
                this.keywordStats.push(item);
                this.keywordStats.sort((a, b) => {
                  if (a.count > b.count) {
                    return -1;
                  }
                  if (a.count < b.count) {
                    return 1;
                  }
                  return 0;
                });
              }
            });
            this.requestClickBusy = false;
            this.$store.commit("clients/setLoading", false);

            if (
              this.keywordStats.length < this.keywordsList.length &&
              this.searchTagQuery.length === 0
            ) {
              this.fetchStatsData();
            }
            if (!this.open) {
              this.keywordsList = [];
              this.keywordStats = [];
            }
            //
          });
      }
    },

    fetchFullStats() {
      if (this.open) {
        this.$store.commit("clients/setLoading", true);

        this.requestFullStatsBusy = true;
        // let id;
        //
        // id = this.keywordFullStats.length;

        let url = `client/stats/multiselect/${this.sector}/full_stats`;

        apiClientCreator(url)
          .get("", { params: this.queryObject })
          .then(res => {
            res.data.map(item => {
              if (this.open) {
                this.keywordFullStats.push(item);
                this.keywordFullStats.sort((a, b) => {
                  if (a.pl > b.pl) {
                    return -1;
                  }
                  if (a.pl < b.pl) {
                    return 1;
                  }
                  return 0;
                });
              }
            });
            this.handleChartLoad("PL");
            this.requestFullStatsBusy = false;
            this.$store.commit("clients/setLoading", false);
            if (this.keywordFullStats.length < this.selectedItems.length) {
            }
            if (!this.open) {
              this.keywordFullStats = [];
            }
            //
          });
      }
    },

    // manageKeywordsStatus(campId, status) {
    //   /*      this.$store.commit("clients/setLoading", true);
    //   this.requestCloseCamp = true;
    //   apiClientCreator(`admin/campaigns/${campId}`)
    //     .post("", { status: status })
    //     .then(res => {
    //       this.requestCloseCamp = false;
    //       this.$store.commit("clients/setLoading", false);
    //       this.keywordFullStats = [];
    //       this.selectedCampIdForPopup = null;
    //     });*/
    // },

    getStats(i) {
      const stat = this.keywordStats.find(item => item.type === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },

    outClose() {
      if (this.open === true && this.selectedKeywordMsTab === "MAIN") {
        this.$emit("input", this.selectedItems);
        this.closeSelect();
      }
    },
    checkSelectAll: function() {
      this.selectedItems = [];
      let type;
      if (!this.selectAll) {
        for (type in this.keywordStats) {
          this.selectedItems.push(this.keywordStats[type]);
        }
      }
      this.selectAll = !this.selectAll;
    },
    closeSelect() {
      this.searchTagQuery = "";
      this.showResults = false;
      this.open = false;
      this.$store.commit("clients/setChartsMainView", "DEP");
    },
    resetSelect() {
      this.selectedItems = [];
      this.selectedCampForChart = [];
      this.selectAll = false;
      this.$emit("input", this.selectedItems);
      this.$store.commit("clients/setChartsMainView", "DEP");
      this.$emit("reset");
      this.closeSelect();
    },

    applyAlphaSorting() {
      let currentSortOrder = this.sortOrderAlpha;

      // reverse sortOrder
      if (this.sortOrderAlpha.toString() === "asc") {
        this.sortOrderAlpha = "desc";
        currentSortOrder = "desc";
        return this.keywordStats.sort((a, b) => {
          if (a.type > b.type) {
            return -1;
          }
          if (a.type < b.type) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAlpha.toString() === "desc") {
        this.sortOrderAlpha = "asc";
        currentSortOrder = "asc";
        return this.keywordStats.sort((a, b) => {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSorting() {
      let currentSortOrder = this.sortOrderAmount;

      // reverse sortOrder
      if (this.sortOrderAmount.toString() === "asc") {
        this.sortOrderAmount = "desc";
        currentSortOrder = "desc";

        return this.keywordStats.sort((a, b) => {
          if (a.count > b.count) {
            return -1;
          }
          if (a.count < b.count) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmount.toString() === "desc") {
        this.sortOrderAmount = "asc";
        currentSortOrder = "asc";
        return this.keywordStats.sort((a, b) => {
          if (a.count < b.count) {
            return -1;
          }
          if (a.count > b.count) {
            return 1;
          }
          return 0;
        });
      }
    },
    applySortingById() {
      let currentSortOrder = this.sortOrderId;
      // reverse sortOrder
      if (this.sortOrderId.toString() === "asc") {
        this.sortOrderId = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.key > b.key) {
            return -1;
          }
          if (a.key < b.key) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderId.toString() === "desc") {
        this.sortOrderId = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.key < b.key) {
            return -1;
          }
          if (a.key > b.key) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingAll() {
      let currentSortOrder = this.sortOrderAmountAll;

      // reverse sortOrder
      if (this.sortOrderAmountAll.toString() === "asc") {
        this.sortOrderAmountAll = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.all > b.all) {
            return -1;
          }
          if (a.all < b.all) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountAll.toString() === "desc") {
        this.sortOrderAmountAll = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.all < b.all) {
            return -1;
          }
          if (a.all > b.all) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingAll() {
      let currentSortOrder = this.sortOrderPercentAll;

      // reverse sortOrder
      if (this.sortOrderPercentAll.toString() === "asc") {
        this.sortOrderPercentAll = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.all_percent > b.all_percent) {
            return -1;
          }
          if (a.all_percent < b.all_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentAll.toString() === "desc") {
        this.sortOrderPercentAll = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.all_percent < b.all_percent) {
            return -1;
          }
          if (a.all_percent > b.all_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingAll() {
      let currentSortOrder = this.sortOrderCostAll;

      // reverse sortOrder
      if (this.sortOrderCostAll.toString() === "asc") {
        this.sortOrderCostAll = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.all_cost > b.all_cost) {
            return -1;
          }
          if (a.all_cost < b.all_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostAll.toString() === "desc") {
        this.sortOrderCostAll = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.all_cost < b.all_cost) {
            return -1;
          }
          if (a.all_cost > b.all_cost) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingNa() {
      let currentSortOrder = this.sortOrderAmountNa;

      // reverse sortOrder
      if (this.sortOrderAmountNa.toString() === "asc") {
        this.sortOrderAmountNa = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.na > b.na) {
            return -1;
          }
          if (a.na < b.na) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountNa.toString() === "desc") {
        this.sortOrderAmountNa = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.na < b.na) {
            return -1;
          }
          if (a.na > b.na) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyPercentSortingNa() {
      let currentSortOrder = this.sortOrderPercentNa;

      // reverse sortOrder
      if (this.sortOrderPercentNa.toString() === "asc") {
        this.sortOrderPercentNa = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.na_percent > b.na_percent) {
            return -1;
          }
          if (a.na_percent < b.na_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentNa.toString() === "desc") {
        this.sortOrderPercentNa = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.na_percent < b.na_percent) {
            return -1;
          }
          if (a.na_percent > b.na_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingNa() {
      let currentSortOrder = this.sortOrderCostNa;

      // reverse sortOrder
      if (this.sortOrderCostNa.toString() === "asc") {
        this.sortOrderCostNa = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.na_cost > b.na_cost) {
            return -1;
          }
          if (a.na_cost < b.na_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostNa.toString() === "desc") {
        this.sortOrderCostNa = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.na_cost < b.na_cost) {
            return -1;
          }
          if (a.na_cost > b.na_cost) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingNi() {
      let currentSortOrder = this.sortOrderAmountNi;

      // reverse sortOrder
      if (this.sortOrderAmountNi.toString() === "asc") {
        this.sortOrderAmountNi = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ni > b.ni) {
            return -1;
          }
          if (a.ni < b.ni) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountNi.toString() === "desc") {
        this.sortOrderAmountNi = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ni < b.ni) {
            return -1;
          }
          if (a.ni > b.ni) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingNi() {
      let currentSortOrder = this.sortOrderPercentNi;

      // reverse sortOrder
      if (this.sortOrderPercentNi.toString() === "asc") {
        this.sortOrderPercentNi = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ni_percent > b.ni_percent) {
            return -1;
          }
          if (a.ni_percent < b.ni_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentNi.toString() === "desc") {
        this.sortOrderPercentNi = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ni_percent < b.ni_percent) {
            return -1;
          }
          if (a.ni_percent > b.ni_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingNi() {
      let currentSortOrder = this.sortOrderCostNi;

      // reverse sortOrder
      if (this.sortOrderCostNi.toString() === "asc") {
        this.sortOrderCostNi = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ni_cost > b.ni_cost) {
            return -1;
          }
          if (a.ni_cost < b.ni_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostNi.toString() === "desc") {
        this.sortOrderCostNi = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ni_cost < b.ni_cost) {
            return -1;
          }
          if (a.ni_cost > b.ni_cost) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingBn() {
      let currentSortOrder = this.sortOrderAmountBn;
      // reverse sortOrder
      if (this.sortOrderAmountBn.toString() === "asc") {
        this.sortOrderAmountBn = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.bn > b.bn) {
            return -1;
          }
          if (a.bn < b.bn) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountBn.toString() === "desc") {
        this.sortOrderAmountBn = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.bn < b.bn) {
            return -1;
          }
          if (a.bn > b.bn) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingBn() {
      let currentSortOrder = this.sortOrderPercentBn;
      // reverse sortOrder
      if (this.sortOrderPercentBn.toString() === "asc") {
        this.sortOrderPercentBn = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.bn_percent > b.bn_percent) {
            return -1;
          }
          if (a.bn_percent < b.bn_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentBn.toString() === "desc") {
        this.sortOrderPercentBn = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.bn_percent < b.bn_percent) {
            return -1;
          }
          if (a.bn_percent > b.bn_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingBn() {
      let currentSortOrder = this.sortOrderCostBn;

      // reverse sortOrder
      if (this.sortOrderCostBn.toString() === "asc") {
        this.sortOrderCostBn = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.bn_cost > b.bn_cost) {
            return -1;
          }
          if (a.bn_cost < b.bn_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostBn.toString() === "desc") {
        this.sortOrderCostBn = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.bn_cost < b.bn_cost) {
            return -1;
          }
          if (a.bn_cost > b.bn_cost) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingT4() {
      let currentSortOrder = this.sortOrderAmountT4;
      // reverse sortOrder
      if (this.sortOrderAmountT4.toString() === "asc") {
        this.sortOrderAmountT4 = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.t4 > b.t4) {
            return -1;
          }
          if (a.t4 < b.t4) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountT4.toString() === "desc") {
        this.sortOrderAmountT4 = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.t4 < b.t4) {
            return -1;
          }
          if (a.t4 > b.t4) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyPercentSortingT4() {
      let currentSortOrder = this.sortOrderPercentT4;
      // reverse sortOrder
      if (this.sortOrderPercentT4.toString() === "asc") {
        this.sortOrderPercentT4 = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.t4_percent > b.t4_percent) {
            return -1;
          }
          if (a.t4_percent < b.t4_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentT4.toString() === "desc") {
        this.sortOrderPercentT4 = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.t4_percent < b.t4_percent) {
            return -1;
          }
          if (a.t4_percent > b.t4_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingT4() {
      let currentSortOrder = this.sortOrderCostT4;

      // reverse sortOrder
      if (this.sortOrderCostT4.toString() === "asc") {
        this.sortOrderCostT4 = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.t4_cost > b.t4_cost) {
            return -1;
          }
          if (a.t4_cost < b.t4_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostT4.toString() === "desc") {
        this.sortOrderCostT4 = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.t4_cost < b.t4_cost) {
            return -1;
          }
          if (a.t4_cost > b.t4_cost) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingEnded() {
      let currentSortOrder = this.sortOrderAmountEnded;
      // reverse sortOrder
      if (this.sortOrderAmountEnded.toString() === "asc") {
        this.sortOrderAmountEnded = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ended > b.ended) {
            return -1;
          }
          if (a.ended < b.ended) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountEnded.toString() === "desc") {
        this.sortOrderAmountEnded = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ended < b.ended) {
            return -1;
          }
          if (a.ended > b.ended) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyPercentSortingEnded() {
      let currentSortOrder = this.sortOrderPercentEnded;
      // reverse sortOrder
      if (this.sortOrderPercentEnded.toString() === "asc") {
        this.sortOrderPercentEnded = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ended_percent > b.ended_percent) {
            return -1;
          }
          if (a.ended_percent < b.ended_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentEnded.toString() === "desc") {
        this.sortOrderPercentEnded = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ended_percent < b.ended_percent) {
            return -1;
          }
          if (a.ended_percent > b.ended_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingEnded() {
      let currentSortOrder = this.sortOrderCostEnded;

      // reverse sortOrder
      if (this.sortOrderCostEnded.toString() === "asc") {
        this.sortOrderCostEnded = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ended_cost > b.ended_cost) {
            return -1;
          }
          if (a.ended_cost < b.ended_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostEnded.toString() === "desc") {
        this.sortOrderCostEnded = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ended_cost < b.ended_cost) {
            return -1;
          }
          if (a.ended_cost > b.ended_cost) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingTotal() {
      let currentSortOrder = this.sortOrderAmountTotal;
      // reverse sortOrder
      if (this.sortOrderAmountTotal.toString() === "asc") {
        this.sortOrderAmountTotal = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.total > b.total) {
            return -1;
          }
          if (a.total < b.total) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountTotal.toString() === "desc") {
        this.sortOrderAmountTotal = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.total < b.total) {
            return -1;
          }
          if (a.total > b.total) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingTotal() {
      let currentSortOrder = this.sortOrderPercentTotal;
      // reverse sortOrder
      if (this.sortOrderPercentTotal.toString() === "asc") {
        this.sortOrderPercentTotal = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.total_percent > b.total_percent) {
            return -1;
          }
          if (a.total_percent < b.total_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentTotal.toString() === "desc") {
        this.sortOrderPercentTotal = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.total_percent < b.total_percent) {
            return -1;
          }
          if (a.total_percent > b.total_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingTotal() {
      let currentSortOrder = this.sortOrderCostTotal;

      // reverse sortOrder
      if (this.sortOrderCostTotal.toString() === "asc") {
        this.sortOrderCostTotal = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.total_cost > b.total_cost) {
            return -1;
          }
          if (a.total_cost < b.total_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostTotal.toString() === "desc") {
        this.sortOrderCostTotal = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.total_cost < b.total_cost) {
            return -1;
          }
          if (a.total_cost > b.total_cost) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingDep() {
      let currentSortOrder = this.sortOrderAmountDep;

      // reverse sortOrder
      if (this.sortOrderAmountDep.toString() === "asc") {
        this.sortOrderAmountDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.dep > b.dep) {
            return -1;
          }
          if (a.dep < b.dep) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountDep.toString() === "desc") {
        this.sortOrderAmountDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.dep < b.dep) {
            return -1;
          }
          if (a.dep > b.dep) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingDep() {
      let currentSortOrder = this.sortOrderPercentDep;

      // reverse sortOrder
      if (this.sortOrderPercentDep.toString() === "asc") {
        this.sortOrderPercentDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.dep_percent > b.dep_percent) {
            return -1;
          }
          if (a.dep_percent < b.dep_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentDep.toString() === "desc") {
        this.sortOrderPercentDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.dep_percent < b.dep_percent) {
            return -1;
          }
          if (a.dep_percent > b.dep_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingDep() {
      let currentSortOrder = this.sortOrderCostDep;

      // reverse sortOrder
      if (this.sortOrderCostDep.toString() === "asc") {
        this.sortOrderCostDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.dep_cost > b.dep_cost) {
            return -1;
          }
          if (a.dep_cost < b.dep_cost) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostDep.toString() === "desc") {
        this.sortOrderCostDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.dep_cost < b.dep_cost) {
            return -1;
          }
          if (a.dep_cost > b.dep_cost) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingDepTotal() {
      let currentSortOrder = this.sortOrderAmountTotalDep;

      // reverse sortOrder
      if (this.sortOrderAmountTotalDep.toString() === "asc") {
        this.sortOrderAmountTotalDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep > b.ov_dep) {
            return -1;
          }
          if (a.ov_dep < b.ov_dep) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountTotalDep.toString() === "desc") {
        this.sortOrderAmountTotalDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep < b.ov_dep) {
            return -1;
          }
          if (a.ov_dep > b.ov_dep) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyPercentSortingDepTotal() {
      let currentSortOrder = this.sortOrderPercentTotalDep;

      // reverse sortOrder
      if (this.sortOrderPercentTotalDep.toString() === "asc") {
        this.sortOrderPercentTotalDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep_percent > b.ov_dep_percent) {
            return -1;
          }
          if (a.ov_dep_percent < b.ov_dep_percent) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderPercentTotalDep.toString() === "desc") {
        this.sortOrderPercentTotalDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep_percent < b.ov_dep_percent) {
            return -1;
          }
          if (a.ov_dep_percent > b.ov_dep_percent) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingDepTotal() {
      let currentSortOrder = this.sortOrderCostTotalDep;

      // reverse sortOrder
      if (this.sortOrderCostTotalDep.toString() === "asc") {
        this.sortOrderCostTotalDep = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep_avg_cpa > b.ov_dep_avg_cpa) {
            return -1;
          }
          if (a.ov_dep_avg_cpa < b.ov_dep_avg_cpa) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostTotalDep.toString() === "desc") {
        this.sortOrderCostTotalDep = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ov_dep_avg_cpa < b.ov_dep_avg_cpa) {
            return -1;
          }
          if (a.ov_dep_avg_cpa > b.ov_dep_avg_cpa) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingCTR() {
      let currentSortOrder = this.sortOrderAmountCTR;
      // reverse sortOrder
      if (this.sortOrderAmountCTR.toString() === "asc") {
        this.sortOrderAmountCTR = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.ctr > b.ctr) {
            return -1;
          }
          if (a.ctr < b.ctr) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountCTR.toString() === "desc") {
        this.sortOrderAmountCTR = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.ctr < b.ctr) {
            return -1;
          }
          if (a.ctr > b.ctr) {
            return 1;
          }
          return 0;
        });
      }
    },

    applyAmountSortingCR() {
      let currentSortOrder = this.sortOrderAmountCR;
      // reverse sortOrder
      if (this.sortOrderAmountCR.toString() === "asc") {
        this.sortOrderAmountCR = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.cr > b.cr) {
            return -1;
          }
          if (a.cr < b.cr) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountCR.toString() === "desc") {
        this.sortOrderAmountCR = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.cr < b.cr) {
            return -1;
          }
          if (a.cr > b.cr) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingPL() {
      let currentSortOrder = this.sortOrderCostPL;
      // reverse sortOrder
      if (this.sortOrderCostPL.toString() === "asc") {
        this.sortOrderCostPL = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.pl > b.pl) {
            return -1;
          }
          if (a.pl < b.pl) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostPL.toString() === "desc") {
        this.sortOrderCostPL = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.pl < b.pl) {
            return -1;
          }
          if (a.pl > b.pl) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyAmountSortingFuture() {
      let currentSortOrder = this.sortOrderAmountFuture;
      // reverse sortOrder
      if (this.sortOrderAmountFuture.toString() === "asc") {
        this.sortOrderAmountFuture = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.future_dep_count > b.future_dep_count) {
            return -1;
          }
          if (a.future_dep_count < b.future_dep_count) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderAmountFuture.toString() === "desc") {
        this.sortOrderAmountFuture = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.future_dep_count < b.future_dep_count) {
            return -1;
          }
          if (a.future_dep_count > b.future_dep_count) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyCostSortingFuture() {
      let currentSortOrder = this.sortOrderCostFuture;
      // reverse sortOrder
      if (this.sortOrderCostFuture.toString() === "asc") {
        this.sortOrderCostFuture = "desc";
        currentSortOrder = "desc";

        return this.keywordFullStats.sort((a, b) => {
          if (a.future_pl > b.future_pl) {
            return -1;
          }
          if (a.future_pl < b.future_pl) {
            return 1;
          }
          return 0;
        });
      }

      if (this.sortOrderCostFuture.toString() === "desc") {
        this.sortOrderCostFuture = "asc";
        currentSortOrder = "asc";
        return this.keywordFullStats.sort((a, b) => {
          if (a.future_pl < b.future_pl) {
            return -1;
          }
          if (a.future_pl > b.future_pl) {
            return 1;
          }
          return 0;
        });
      }
    },

    sumActive() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        all_cost: a.all_cost + b.all_cost
      }));
      const count = this.keywordFullStats.reduce((a, b) => ({
        all: a.all + b.all
      }));
      /*      const average =
                  this.keywordFullStats.reduce(
                    (total, next) => total + next.all_percent,
                    0
                  ) / this.keywordFullStats.length;*/
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.all / total.total) * 100;
      return {
        cost_total: cost.all_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.all.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    sumNa() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        na_cost: a.na_cost + b.na_cost
      }));
      const count = this.keywordFullStats.reduce((a, b) => ({
        na: a.na + b.na
      }));
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.na / total.total) * 100;
      /*      const average =
                  this.keywordFullStats.reduce((total, next) => total + next.na_percent, 0) /
                  this.keywordFullStats.length;*/
      return {
        cost_total: cost.na_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.na.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },
    sumNi() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        ni_cost: a.ni_cost + b.ni_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  ni_percent: a.ni_percent + b.ni_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        ni: a.ni + b.ni
      }));
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.ni / total.total) * 100;
      /*
                const average =
                  this.keywordFullStats.reduce((total, next) => total + next.ni_percent, 0) /
                  this.keywordFullStats.length;
          */

      return {
        cost_total: cost.ni_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.ni.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },
    sumBn() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        bn_cost: a.bn_cost + b.bn_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  bn_percent: a.bn_percent + b.bn_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        bn: a.bn + b.bn
      }));
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.bn / total.total) * 100;
      /*      const average =
                  this.keywordFullStats.reduce((total, next) => total + next.bn_percent, 0) /
                  this.keywordFullStats.length;*/
      return {
        cost_total: cost.bn_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.bn.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },
    sumT4() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        t4_cost: a.t4_cost + b.t4_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  t4_percent: a.t4_percent + b.t4_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        t4: a.t4 + b.t4
      }));
      /*
                const average =
                  this.keywordFullStats.reduce((total, next) => total + next.t4_percent, 0) /
                  this.keywordFullStats.length;
          */
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.t4 / total.total) * 100;
      return {
        cost_total: cost.t4_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.t4.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    sumEnded() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        ended_cost: a.ended_cost + b.ended_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  t4_percent: a.t4_percent + b.t4_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        ended: a.ended + b.ended
      }));
      /*
                const average =
                  this.keywordFullStats.reduce((total, next) => total + next.t4_percent, 0) /
                  this.keywordFullStats.length;
          */
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.ended / total.total) * 100;
      return {
        cost_total: cost.ended_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.ended
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    sumClientsDep() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        dep_cost: a.dep_cost + b.dep_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  dep_percent: a.dep_percent + b.dep_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        dep: a.dep + b.dep
      }));
      /*      const average =
                  this.keywordFullStats.reduce(
                    (total, next) => total + next.dep_percent,
                    0
                  ) / this.keywordFullStats.length;*/
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (count.dep / total.total) * 100;

      return {
        cost_total: cost.dep_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: count.dep.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },
    sumClientsTotal() {
      // ALL in TH
      const cost = this.keywordFullStats.reduce((a, b) => ({
        total_cost: a.total_cost + b.total_cost
      }));
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  total_percent: a.total_percent + b.total_percent
                }));*/
      const count = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      return {
        cost_total: cost.total_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        /*percent_total: percent.total_percent.toFixed(0),*/
        count_total: count.total
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    sumClientsTotalDep() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        dep_cost: a.dep_cost + b.dep_cost
      }));

      const ov = this.keywordFullStats.reduce((a, b) => ({
        ov_dep: a.ov_dep + b.ov_dep
      }));
      const total = this.keywordFullStats.reduce((a, b) => ({
        total: a.total + b.total
      }));
      const average = (ov.ov_dep / total.total) * 100; /// this.keywordFullStats.reduce((total, next) => total + next.ov_dep_percent, 0) / this.keywordFullStats.length;

      return {
        cost_total: cost.dep_cost
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        percent_total: average.toFixed(0),
        count_total: ov.ov_dep.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    sumCR() {
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  cr: a.cr + b.cr
                }));*/
      const ov = this.keywordFullStats.reduce((a, b) => ({
        ov_dep: a.ov_dep + b.ov_dep
      }));
      const dep = this.keywordFullStats.reduce((a, b) => ({
        dep: a.dep + b.dep
      }));
      const average = ov.ov_dep / dep.dep;
      return {
        percent_total: average.toFixed(2)
      };
    },
    sumCTR() {
      /*      const percent = this.keywordFullStats.reduce((a, b) => ({
                  cr: a.cr + b.cr
                }));*/
      const ov = this.keywordFullStats.reduce((a, b) => ({
        dep_cost: a.dep_cost + b.dep_cost
      }));

      const total = this.keywordFullStats.reduce((a, b) => ({
        total_cost: a.total_cost + b.total_cost
      }));

      const average = ov.dep_cost / total.total_cost;
      return {
        ctr: average.toFixed(2)
      };
    },
    sumPL() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        pl: a.pl + b.pl
      }));
      return {
        cost_total: cost.pl.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    },

    // ((stat.ov_dep_percent/100) * stat.all).toFixed(0)}}

    //  (2700 * ((stat.ov_dep_percent/100) * stat.all)).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    sumFuture() {
      const cost = this.keywordFullStats.reduce((a, b) => ({
        future_pl: a.future_pl + b.future_pl
      }));
      const count = this.keywordFullStats.reduce((a, b) => ({
        future_dep_count: a.future_dep_count + b.future_dep_count
      }));

      return {
        cost_total: cost.future_pl,
        count_total: count.future_dep_count
      };
    },

    paginate(arr, page_number, page_size) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },

    nextPage() {
      /*      const checkLength = this.paginate(this.keywordFullStats, this.pageNum+1, 4);
                if(checkLength.length===0){
                  return
                }*/
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },

    statsNextPage() {
      /*      const checkLength = this.paginate(this.keywordFullStats, this.pageNum+1, 4);
                if(checkLength.length===0){
                  return
                }*/
      this.statsPageNum = this.statsPageNum + 1;
    },
    statsBackPage() {
      if (this.statsPageNum > 1) {
        this.statsPageNum = this.statsPageNum - 1;
      }
    },

    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.keywordStats.filter(item => {
        return searchRegex.test(item.type);
      });
    },
    formatDateTimeTable(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm ");
    }
  },
  watch: {
    // msSelectedItems(){
    //   if(this.msSelectedItems.length > 0 && this.open && this.showStatistics){
    //     this.fetchFullStats()
    //   }
    // },
    showStatistics() {
      if (this.showStatistics && this.msSelectedItems.length > 0) {
        this.fetchFullStats();
      }
    },
    showAllDataStatus: function() {
      if (this.keywordFullStats.length > 0) {
        this.selectedChartType = this.showAllDataStatus;
        this.handleChartLoad(this.selectedChartCat, this.selectedChartSubCat);
      }
    },

    selectedCampForChart: function() {
      // console.log(this.selectedCampForChart);
      /*      const checkLen = this.paginate(this.selectedCampForChart,this.pageNum+1,6);
                if(checkLen.length>0){
                  this.$store.commit("clients/setCampChartData", this.paginate(this.selectedCampForChart,this.pageNum,6));
                }*/
      /*    if (this.selectedChartCat !== null) {
                  this.handleChartLoad(this.selectedChartCat);
                }*/
    },
    pageNum: function() {
      /*      let arr = this.paginate(this.keywordFullStats,this.pageNum,6);
                this.selectedCampForChart.forEach(stat=>{
                  arr = arr.filter(item=>item.key !== stat.key)
                })
               console.log(6-arr.length)
                const checkLen =this.paginate(this.selectedCampForChart,this.pageNum,6-arr.length);
                if(checkLen.length>0){
                this.$store.commit("clients/setCampChartData", this.paginate(this.selectedCampForChart,this.pageNum,6-arr.length));*/
      if (this.selectedChartCat !== null) {
        this.handleChartLoad(this.selectedChartCat);
      }
    },
    selectedKeywordMsTab: function() {
      if (this.selectedKeywordMsTab === "STATS") {
        this.$emit("stats_sel");
        this.$emit("input", this.selectedItems);
        this.keywordFullStats = [];

        /*        if (!this.queryObject.hasOwnProperty("registered_on_from")) {
                      // alert()
                      if(this.filterDepTimeFrame==='THIS_MONTH' || this.filterDepTimeFrame==='TODAY'){
                      this.$store.commit("clients/setSelectRegCalMonth", true);
                      }
                      if(this.filterDepTimeFrame==='LAST_MONTH'){
                        this.$store.commit("clients/setSelectRegCalLastMonth", true);
                      }

                      //// add custom range from dep cal
                    }*/
        //  setTimeout(() => {
        //   if (!this.initiatedFiltering) {
        /*            if (
                              this.queryObject.hasOwnProperty("registered_on_from") &&
                              this.queryObject.hasOwnProperty("deposit_at_from")
                            ) {
                            }*/
        //  this.keywordFullStats = [];
        //  }
        //  }, 2500);
      }
      if (
        this.selectedKeywordMsTab === "MAIN" //&&
        // this.keywordFullStats.length === 0
      ) {
        this.$emit("main_sel");
        this.$store.commit("clients/setChartsMainView", "DEP");

        this.keywordStats = [];
        this.fetchStats();
      }
    },
    searchTagQuery: function() {
      /*      this.selectedItems.length > 0 && this.searchTagQuery.length === 0
                  ? (this.showItemsCount = true)
                  : (this.showItemsCount = false);
                this.result = this.filterList(this.searchTagQuery);
                if (this.result.length > 0) {
                  this.showResults = true;
                }
                if (this.searchTagQuery === "") {
                  this.showResults = false;
                }*/
      this.keywordsList = [];
      this.keywordStats = [];
      this.searchStats(this.searchTagQuery);
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedItems = [];
      }
    },
    selectedItems: function() {
      if (this.selectedItems.length > 0 && this.searchTagQuery.length === 0) {
        this.showItemsCount = true;
      } else {
        this.showItemsCount = false;
      }
    },
    open() {
      //   if (this.open ) {
      //     //console.log("open  from stats")
      //     // if (
      //     //     this.selectedKeywordMsTab === "STATS" &&
      //     //     this.selectedItems.length === 0
      //     // ) {
      //     //   this.selectedKeywordMsTab = "MAIN";
      //     // }
      //     // if (this.selectedKeywordMsTab === "MAIN") {
      //     //   this.fetchStats();
      //     // }
      //     if (this.selectedKeywordMsTab === "MAIN") {
      //       this.fetchFullStats();
      //     }
      //   }
      if (!this.open) {
        this.keywordsList = [];
        this.keywordStats = [];
        this.keywordFullStats = [];
      }
    },
    initiatedFiltering() {
      //  console.log(this.initiatedFiltering)
      if (this.initiatedFiltering && this.keywordStats.length > 0) {
        this.keywordStats = [];
        this.keywordFullStats = [];
      }
      if (!this.initiatedFiltering && this.selectedKeywordMsTab === "STATS") {
        setTimeout(() => {
          // if (!this.initiatedFiltering) {
          this.keywordFullStats = [];
          this.fetchFullStats();
          //   }
        }, 2500);
      }
    }
  }
};
</script>

<style scoped>
.floating-wrapper {
  position: relative;
}

.selsected-count {
  position: absolute;
  top: 8px;
  left: 10px;
  background: white;
  font-size: 8pt;
  height: 20px;
  width: 80%;
}

/*.root {*/
/*  position: absolute;*/
/*  top: 30px;*/
/*  left: 0px;*/
/*  min-width: 250px;*/
/*  z-index: 10001;*/
/*  padding: 5px;*/
/*  background-color: #fff;*/
/*  border: solid 1px #e4e8ea;*/
/*  !*-webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*!*/
/*  !*-moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*!*/
/*  !*box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*!*/
/*  !*box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*!*/
/*  font-family: Montserrat !important;*/
/*}*/

/*.root-big {*/
/*  position: absolute;*/
/*  top: 66%;*/
/*  left: 0;*/
/*  right: 0;*/
/*  min-width: 250px;*/
/*  z-index: 3;*/
/*  padding: 5px;*/
/*  background-color: #fff;*/
/*  border: solid 1px #e4e8ea;*/
/*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
/*  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
/*  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/

/*  font-family: Montserrat !important;*/
/*  height: max-content;*/
/*  min-height: 250px;*/
/*}*/
/*.root-big-enlarged {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  min-width: 250px;*/
/*  z-index: 1;*/
/*  padding: 5px;*/
/*  background-color: #fff;*/
/*  border: solid 1px #e4e8ea;*/
/*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
/*  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
/*  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/

/*  font-family: Montserrat !important;*/
/*  height: max-content;*/
/*  min-height: 250px;*/
/*}*/
.close-history-popup {
  position: absolute;
  top: 24px;
  right: 0;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border-radius: 3px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  font-size: 12px;
}
ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.item-text {
  font-size: 9pt;
}

.item-checkbox {
  margin-right: 5px;
}

.item-counter {
  font-size: 8pt;
  float: right;
  margin-left: 10px;
  text-align: right;
}

.scroller-div {
  height: auto;
  max-height: 420px;
  overflow-x: hidden;
}

.label-check-all {
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}

.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}

.tag-form-cancel-btn {
  /*color: red !important;*/
  color: green !important;
  margin-left: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;

  margin-right: 5px;
  margin-top: 5px;
}

.input-main {
  /*margin-left: 4px;*/
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  /*border-radius: 4px;*/
  border: 0.1px solid #fff4f4;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  cursor: pointer;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  /*box-shadow: 0 0 5px rgba(81, 203, 238, 1);*/
  /* padding: 3px 0px 3px 3px;*/
  /*border: 1px solid rgba(81, 203, 238, 1);*/
  outline: none;
}

.dropdown-divider {
  height: 1px;
  margin: 5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.ids-count-label {
  font-weight: bold;
  font-size: 8pt;
  margin-left: 10px;
}

.override {
  margin-left: 5px;
  margin-bottom: 5px;
  height: 20px;
  padding-top: 3px;
  font-size: 11px;
  line-height: 11px;
}

.fa {
  width: 7px;
}

.spinner-bottom-ms {
  position: absolute;
  right: 20px;
  top: 5px;
}

.nav {
  height: 20px;
  margin-bottom: 10px;
}

.nav-tabs a {
  height: 20px;
  padding: 5px;
  font-size: 8pt;
}

.nav-tabs a:hover {
  background: #eceff1;
}

.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-size: 10pt;
  font-weight: bold;
  color: #1e88e5;
}

.nav-tabs li {
  margin: 0px;
}

.nav-tabs li:hover {
  background: none;
  margin: 0;
}

.tab-stats {
  font-size: 8pt;
  margin-left: 14px;
}

.table {
  margin-bottom: 0;
}
.stats-tab-adv {
  min-width: 1600px;
  max-width: 1600px;
  width: 100%;
  position: absolute;
  top: 226px;
  right: -500px !important;
}
.stats-tab {
  min-width: 1600px;
  max-width: 1600px;
  width: 100%;
  position: absolute;
  top: 226px;
  right: -300px;
}

.stats-tab-p {
  min-width: 1600px;
  max-width: 1600px;
  width: 100%;
  position: absolute;
  top: 60px;
  right: -30px;
}
.stats-tab-l {
  min-width: 1600px;
  max-width: 1600px;
  width: 100%;
  position: absolute;
  top: 240px;
  right: -40px;
}

.stats-table {
  width: 100%;
  background-color: #fff;

  text-align: center;
  font-size: 12px;
}

.td-camp {
  width: 100px;
  cursor: pointer;
}
.td-camp:hover {
  color: white;
  background: #44a2d2;
}
.stats-table th {
  font-weight: normal;
  text-align: center;
}

.stats-table td {
  font-weight: normal;
  text-align: center;
}

.stats-table tfoot {
  border-top: #44a2d2 solid 2px;
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.funnel-up {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.bg-blue {
  background: #44a2d2;
  color: white;
}

.filter-btn {
  font-size: 15px;
}

.filter-btn-font {
  font-family: Montserrat !important;
}

.filter-btn-font-shekel {
  font-family: Montserrat !important;
  font-size: 13px !important;
  margin-top: -3px !important;
}

::placeholder {
  color: #b9b9b9;
  opacity: 1; /* Firefox */
}

.top-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 1.5rem;
  margin-left: 2.5rem;
  text-indent: -15px;
  font-size: 12px;
}

.top-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}

.top-check-div {
  display: inline-flex;
}
.td-check {
  display: inline-flex;
}
.red-pl {
  color: red;
}

.green-pl {
  color: green;
}

.th-camp {
  min-width: 170px;
}

.btn-highlight {
  box-shadow: 0 0 5px #44a2d2;
  border: 1px solid #44a2d2;
}

.paginationContainer {
  /*margin-left: 10px;*/
  width: 110px;
  margin-left: auto;
  margin-right: auto;
}

.paginationContainerStats {
  /*margin-left: 10px;*/
  width: 110px;
  margin-left: auto;
  margin-right: auto;
}

.page-btn {
  background: white;
}

.tag-form-btns {
  display: flex;
}

.pull-left-btn {
  float: left;
}

.page-num {
  cursor: inherit;
}

.charts-icon {
  width: 19px;
  height: 15px;
  margin-bottom: 3px;
  margin-left: 3px;
  cursor: pointer;
}

.bttn {
  width: max-content;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  height: 28px;
}

.bttn-tab {
  width: max-content;
  margin-top: 0.3rem;
  margin-left: 0.5rem;
  background: #efefef;
  color: black;
  border: 0;
  /*border-radius: inherit;*/
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1px;
  font-family: inherit;
  cursor: pointer;
  height: 22px;
}

.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}

.top-check-div {
  display: inline-flex;
}

.item-counter-text {
  color: white;
  width: 100%;
  background: #44a2d2;
  padding: 1px 3px 1px 3px;
  border-radius: inherit;
}
.pointer {
  margin-top: 2px;
  cursor: pointer;
}

.btn-highlight {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: 1px solid rgba(81, 203, 238, 1);
}
.enlarge-div {
  width: 100%;
  height: 10px;
  position: relative;
}
.enlarge-table {
  padding-left: 4px;
  padding-right: 4px;
  background: white;
  border-top: solid 1px black;
  border-radius: 90%;
  position: absolute;
  right: 49.3%;
  top: -18px;
  margin: auto;
  font-size: 20px;
  cursor: pointer;
}
.enlarge-table-down {
  padding-left: 4px;
  padding-right: 4px;
  background: white;
  border-top: solid 1px black;
  border-radius: 90%;
  position: absolute;
  right: 49.3%;
  top: -13px;
  margin: auto;
  font-size: 20px;
  cursor: pointer;
}

.selected-cal {
  font-family: "Montserrat", Montserrat, serif;
  padding: 5px;
  background-color: #efefef;
  color: #44a2d2;
  //font-weight: bold;
  width: 90px;
  cursor: pointer;
  height: 28px;
  font-size: 11px;
}
.dropdown-menu.ul-filters {
  min-width: 90px;
  border-radius: 0px;
}
.ul-filters li {
  margin: 5px;
}
.ul-filters li i {
  margin-right: 20px;
  color: #96281b;
}
.ul-filters li:not(:last-child):after {
  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 70%; /* Change this to whatever width you want. */

  border-bottom: 1px solid rgba(222, 220, 220, 0.36);
}
.ul-filters a {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 12px;
  text-transform: uppercase;
  min-width: 50px;
  cursor: pointer;
}
.activedrop > a {
  background-color: #7eb5dd;
  color: #fff !important;
}
.activedrop > a:hover {
  background-color: #7eb5dd;
  color: #000 !important;
}
.drop-down-root {
  display: flex;
  justify-content: center;
  margin-bottom: 3px;
}
</style>
